<template>
  <svg viewBox="0 0 1199 1722" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M329 559v378h109V391h-95c-10 61-55 93-137 97v71h123zm417 391c163 0 226-139 226-283 0-145-62-284-226-284-161 0-227 142-227 284 0 143 66 283 227 283zM599 124c292 0 528 236 528 528 0 291-236 528-528 528-291 0-528-237-528-528 0-292 237-528 528-528zm147 351c100 0 114 116 114 192 0 127-38 191-114 191-99 0-114-115-114-191s15-192 114-192z" />
  </svg>
</template>
